import { useState } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { purchaseWelcomeKit } from '@/hooks/useStripe';
import Button from '@/components/Button';
import kitImg from '@/assets/package.webp';

export const Route = createFileRoute('/_auth/welcome-kit')({
  component: WelcomeKitPage,
});

function WelcomeKitPage() {
  const purchaseKitMutation = purchaseWelcomeKit();
  const [error, setError] = useState<string | null>(null);

  const handleOrder = async () => {
    setError(null);
    try {
      const res = await purchaseKitMutation.mutateAsync({ returnTo: '/_auth/welcome-kit' });
      if ('redirectUrl' in res && res.redirectUrl) {
        window.location.href = res.redirectUrl;
      } else {
        setError('Unexpected response from payment gateway.');
      }
    } catch (err: any) {
      setError(err?.message || 'Payment failed.');
    }
  };

  return (
    <div className="w-full px-4 py-12 md:pt-20">
      <div className="w-full max-w-6xl mx-auto flex flex-col md:flex-row items-center">
        <div className="flex-1 flex flex-col justify-center px-10 md:pr-8">
          <h1 className="text-5xl font-extrabold text-gray-900 mb-4 leading-tight drop-shadow-sm">GranGuard Welcome Kit</h1>
          <div className="text-3xl font-bold text-purple-700 mb-2">$5 <span className="text-lg font-medium text-gray-500">per kit</span></div>
          <ul className="mb-8 mt-6 space-y-3 text-lg text-gray-800 font-medium">
            <li className="flex items-center gap-2"><span className="text-purple-600 text-xl">✔️</span> Printed security guide & checklist</li>
            <li className="flex items-center gap-2"><span className="text-purple-600 text-xl">✔️</span> Scam prevention wallet card</li>
            <li className="flex items-center gap-2"><span className="text-purple-600 text-xl">✔️</span> Emergency contact magnet</li>
          </ul>
          <p className="text-gray-600 text-base max-w-md mb-10">Kickstart your digital safety journey with our exclusive Welcome Kit. Perfect for yourself or as a thoughtful gift for loved ones.</p>
          <div className="flex flex-col gap-6 w-full max-w-xs">
            {error && <div className="text-red-600 text-sm mb-2">{error}</div>}
            <Button
              type="button"
              variant="primary"
              size="large"
              isLoading={purchaseKitMutation.status === 'pending'}
              fullWidth
              onClick={handleOrder}
            >
              {purchaseKitMutation.status === 'pending' ? 'Processing...' : 'Order Kit'}
            </Button>
          </div>
        </div>
        <div className="flex-1 flex items-center justify-center bg-transparent p-0 md:p-10 max-h-[400px]">
          <img src={kitImg} alt="Welcome Kit" className="w-full max-w-lg h-auto drop-shadow-2xl" />
        </div>
      </div>
    </div>
  );
}